<template>
  <div class="login">
    <div class="login-sidebar">
      <img src="../assets/falksson-logo.png"/>
    </div>
    <div class="login-mask">
      <div class="login-mask-content">
        <h2>Wilkommen</h2>
        <form  v-on:submit.prevent>
          <input type="text" :class="statusClass" placeholder="Benutzername" v-model="username"/>
          <input type="password" :class="statusClass"  placeholder="Passwort" v-model="password"/>
          <input type="submit" v-on:click="submit" value="Anmelden"/>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

  import Navigation from "../components/Navigation";
  import authService from "../services/authService";

  export default {
    name: 'Login',
    data: () => {
      return {
        username: '',
        password: '',
        statusClass: ''
      }
    },
    methods: {
      submit() {
        if(!!this.username && !!this.password) {
          this.statusClass = '';
          const that = this;
          authService.login(this.username, this.password)
          .then(() => {
            that.$router.push('/');
          });
        } else {
          this.statusClass = 'input-error';
        }
        this.username = '';
        this.password = '';
      }
    },
    components: {
        Navigation,
    }
  }
</script>

<style scoped>

  .login {
    width: 100%;
    height: 100%;
    display: flex;
    background: #e2e2e2;
    flex-direction: column;
  }

  .login-sidebar {
    min-height: 80px;
    background: #323232;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-sidebar img {
    height: 40px;
  }

  .login-mask {
    flex: 1;
    background: #323232;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .login-mask-content {
    padding: 20px;
    width: 80%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 5px;
  }

  h2 {
    margin: 0 0 40px 0;
    padding: 0;
    color: #ff9117;
    font-size: 30px;
    font-family: arial;
    font-weight: lighter;
    text-align: left;
    width: 100%;
  }

  input {
    margin: 10px 0;
    border: 0;
    height: 50px;
    width: 100%;
    font-size: 20px;
    border-bottom: 2px solid #c7c7c7;
    outline: none;
  }

  input[type=text]:focus,
  input[type=password]:focus
  {
    border-color: #ff9117;
  }

  .input-error {
    border-bottom: 2px solid #fa4639;
  }

  input[type=submit] {
    margin-top: 60px;
    height: 60px;
    width: 100%;
    background: #ff9117;
    color: #fff;
    font-family: arial;
    font-size: 20px;
    border: 0;
    outline: none;
    border-radius: 5px;
  }

   @media only screen and (min-width: 1000px) {
     .login {
       flex-direction: row;
     }

     .login-sidebar {
       flex: 1;
     }

     .login-sidebar img{
       height: auto;
     }

    .login-mask {
      background: #fff;
    }

    .login-mask-content {
      width: 70%;
    }

     h2 {
       font-size: 36px;
     }

   }

</style>